import { RequestStatus } from '../../../../models';
import type ShortcutsState from '../ShortcutsState';

const INITIAL_STATE: ShortcutsState = {
  personalShortcuts: undefined,
  personalShortcutsStatus: RequestStatus.Idle,
};

export default INITIAL_STATE;
